import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import MasterInvestmentFilter from "../../Rkaas/Investment/ManageInvestment/MasterInvestmentFilter";
import { addInvestmentsToPlan } from "../../../services";
import { getPathWithParam, MANAGE_PLAN_ROUTES } from "../../../utils";
import { get, isEmpty, isNull } from "lodash";
import {
  createPlanStore,
  setManagePlanToastInfo,
  getPlanDetailsAction,
} from "../../../contexts";
const MasterFilterComponent = ({
  fields,
  filteredValues,
  onFormSubmit,
  selectedData,
  setIsLoading,
  planId,
  history,
  setSubmitting,
  flow,
  data,
  investmentData,
}) => {
  const { state, dispatch } = useContext(createPlanStore);
  const addInvToPlan = (data) => {
    setIsLoading(true);
    var reqData = data.map((x) => {
      return {
        investmentId: x.id,
        status: x.status,
        planId: parseInt(planId, 10),
        suspendedFromDate: x.suspendedFromDate,
        suspendedToDate: x.suspendedToDate,
      };
    });
    addInvestmentsToPlan({ addInvestmentInputs: reqData })
      .then((response) => {
        setSubmitting(true);
        if (response) {
          setIsLoading(false);
          dispatch(
            setManagePlanToastInfo({
              showToast: true,
              toastMessage: "Investment added successfully",
            })
          );
          history.push(
            getPathWithParam({
              path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
              pathParam: [flow, planId],
            })
          );
        }
      })
      .catch((ex) => {
        setIsLoading(false);
      });
  };
  return (
    <>
      <div className="d-flex justify-content-space-between">
        <div className="plan-sub-heading mb-1">Manage Investments</div>
        <div className="mb-1">
          <Button
            type="button"
            variant="primary"
            disabled={data
              .map((investment) => investmentData.includes(investment.id))
              .reduce(
                (previousValue, currentValue) => previousValue && currentValue,
                true
              )}
            onClick={() => {
              addInvToPlan(selectedData);
            }}
          >
            Add to plan
          </Button>
        </div>
      </div>
      <MasterInvestmentFilter
        fields={fields}
        filteredValues={filteredValues}
        onFormSubmit={onFormSubmit}
      />
    </>
  );
};

export default MasterFilterComponent;
